module.exports = __webpack_public_path__ + "static/media/shapes.e188faf8.svg";